import { render, staticRenderFns } from "./MessagesBox.vue?vue&type=template&id=7d0aff54&scoped=true&"
import script from "./MessagesBox.vue?vue&type=script&lang=js&"
export * from "./MessagesBox.vue?vue&type=script&lang=js&"
import style0 from "./MessagesBox.vue?vue&type=style&index=0&id=7d0aff54&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0aff54",
  null
  
)

export default component.exports